export const LOGIN_ROUTE_PATH = "/login";
export const HOME_ROUTE_PATH = "/home";
export const REGISTER_ROUTE_PATH = "/register";
export const FORGOT_PASSWORD_ROUTE_PATH = "/forgot-password";
export const RESET_PASSWORD_ROUTE_PATH = "/reset-password";
export const VERIFY_OTP_ROUTE_PATH = "/verify-otp";
export const LOOKUPS_ROUTE_PATH = "/lookups";
export const USERS_ROUTE_PATH = "/system-users";
export const SUB_ACCOUNTS_ROUTE_PATH = "/sub-accounts";
export const API_KEYS_ROUTE_PATH = "/api-keys";
export const GATEWAYS_ROUTE_PATH = "/gateways";
export const EMAIL_GATEWAYS_ROUTE_PATH = "/email-gateways";
export const EMAIL_MARKUPS_ROUTE_PATH = "/email-markups";
export const PAYMENT_GATEWAYS_ROUTE_PATH = "/payment-gateways";
export const DATA_BUNDLE_GATEWAYS_ROUTE_PATH = "/data-bundle-gateways";
export const BANK_TRANSFER_GATEWAYS_ROUTE_PATH = "/bank-transfer-gateways";
export const MOBILE_MONEY_GATEWAYS_ROUTE_PATH = "/mobile-money-gateways";
export const COUNTRY_MARKUPS_ROUTE_PATH = "/country-markups";
export const SMS_REPORTS_ROUTE_PATH = "/sms-reports";
export const EMAIL_REPORTS_ROUTE_PATH = "/email-reports";
export const PAYMENT_REPORTS_ROUTE_PATH = "/payment-reports";
export const SEND_SMS_ROUTE_PATH = "/send-sms";
export const SEND_EMAIL_ROUTE_PATH = "/send-email";
export const DATA_BUNDLES_ROUTE_PATH = "/data-bundles";
export const DATA_BUNDLE_REPORTS_ROUTE_PATH = "/data-bundle-reports";
export const CALLBACKS_ROUTE_PATH = "/callbacks";
export const MONEY_TRANSFER_REPORTS_ROUTE_PATH = "/money-transfer-reports";
export const WALLET_ROUTE_PATH = "/wallet";
export const MONEY_TRANSFERS_ROUTE_PATH = "/money-transfers";
export const PROFILE_ROUTE_PATH = "/profile";
export const LANDING_ROUTE_PATH = "/";
export const DOCUMENTATION_ROUTE_PATH = "/documentation";
export const PRODUCTS_ROUTE_PATH = "/products";
export const APPLICATIONS_ROUTE_PATH = "/applications";
